/**
 * Human-readable duration between startedAt and finishedAt; "—" while still running. Takes both
 * date shapes the generated client produces: the sync run parses `finishedAt` into a Date, the
 * description run keeps it a string.
 */
export const formatDuration = (run: { startedAt: string | Date; finishedAt?: string | Date | null }): string => {
  if (!run.finishedAt) {
    return "—";
  }
  const ms = new Date(run.finishedAt).getTime() - new Date(run.startedAt).getTime();
  if (Number.isNaN(ms) || ms < 0) {
    return "—";
  }
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
};
